import React from 'react';
import Footer from "../../navigation/footerContainer";
import AdminDashboardContainer from './adminDashboard'

export default function AdminDashboardPage(){

    
    return(
        <>
            <AdminDashboardContainer />
            <Footer />
        </>
       
    )
}